import React, { useState } from "react";
import SetupStep from "./components/Steps/Setup/SetupStep";
import ReconciliationStep from "./components/Steps/Reconciliation/ReconciliationStep";
import SavedDataDisplayStep from "./components/Steps/SavedDataDisplayStep";

function App() {
  const [step, setStep] = useState(1);
  const [idList, setIdList] = useState([]);
  const [savedData, setSavedData] = useState([]);
  const [reconciliationType, setReconciliationType] = useState("person");
  const [autoAccept, setAutoAccept] = useState(false);
  const [newSessionKey, setNewSessionKey] = useState(null);
  const [indexForResume, setIndexForResume] = useState(0);


  const handleFinish = () => {
    setStep(3);
  };
  const onSetup = (type, idList, newSessionKey , indexForResume) => {
    setIdList(idList);
    setReconciliationType(type);
    setStep(2);
    setAutoAccept(autoAccept);
    setNewSessionKey(newSessionKey);
    setIndexForResume(indexForResume || 0);
  };

  return (
    <div className="p-4">
      <ol className="flex items-center w-full text-sm font-medium text-center text-gray-500 dark:text-gray-400 sm:text-base">
        <li
          className={`flex md:w-full items-center sm:after:content-[''] after:w-full after:h-1 after:border-b after:border-gray-200 after:border-1 after:hidden sm:after:inline-block after:mx-6 xl:after:mx-10 dark:after:border-gray-700 text-sm ${step === 1 ? "text-blue-600 dark:text-blue-500" : ""}`}
        >
          <span className="flex items-center after:content-['/'] sm:after:hidden after:mx-2 after:text-gray-200 dark:after:text-gray-500">
            {step === 1 && (
              <svg
              className="w-3.5 h-3.5 sm:w-4 sm:h-4 me-2.5"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
              </svg>
            )}
            Setup
          </span>
        </li>
        <li
          className={`flex md:w-full items-center sm:after:content-[''] after:w-full after:h-1 after:border-b after:border-gray-200 after:border-1 after:hidden sm:after:inline-block after:mx-6 xl:after:mx-10 dark:after:border-gray-700 text-sm ${step === 2 ? "text-blue-600 dark:text-blue-500" : ""}`}
        >
          <span className="flex items-center after:content-['/'] sm:after:hidden after:mx-2 after:text-gray-200 dark:after:text-gray-500">
            <span className="me-2">2</span>
            {step === 2 && (
              <svg
                className="w-3.5 h-3.5 sm:w-4 sm:h-4 me-2.5"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
              </svg>
            )}
            Data{" "}
            <span className="hidden sm:inline-flex sm:ms-2">Reconciliation</span>
          </span>
        </li>
        <li
          className={`flex items-center ${step === 3 ? "text-blue-600 dark:text-blue-500" : ""}`}
        >
          {step === 3 && (
            <svg
            className="w-3.5 h-3.5 sm:w-4 sm:h-4 me-2.5"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
            </svg>
          )}
          <span className="me-2">3</span>
          Export
        </li>
      </ol>

      <div className="p-4">
        {step === 1 && <SetupStep onSetup={onSetup} />}
        {step === 2 && (
          <ReconciliationStep
            ids={idList}
            savedData={savedData}
            onSaveData={setSavedData}
            onFinish={handleFinish}
            autoAccept={autoAccept}
            type={reconciliationType}
            currentIndex={indexForResume}
            setCurrentIndex={setIndexForResume}
            sessionKey={newSessionKey}
            setSessionKey={setNewSessionKey}
          />
        )}
        {step === 3 && <SavedDataDisplayStep savedData={savedData} />}
      </div>
    </div>
  );
}

export default App;
